import { microServicesEnum } from '@dr-keyword-commons/enums'

export const microservicesUrisEnum = Object.freeze({
  [microServicesEnum.SOCKET]: process.env.NEXT_PUBLIC_WS_API_URL,
  [microServicesEnum.BACKEND]: process.env.NEXT_PUBLIC_BASE_API_URL
})
